/**
 * Native file inputs keep showing the chosen filename on their own. When a
 * "Delete" button clears or shifts the files held in the component, these
 * helpers bring the inputs back in line so a removed file does not look like
 * it is still attached.
 */

/** Id of the n-th (1-based) input of a group, e.g. inputGroupFile + 01. */
function inputId(idPrefix: string, n: number): string {
  return `${idPrefix}${String(n).padStart(2, '0')}`;
}

/**
 * Make each input of a group show the file stored for its slot.
 * @param idPrefix e.g. 'inputGroupFile' for ids inputGroupFile01..05
 * @param files    file held for each slot (index 0 = first input)
 */
export function syncFileInputs(
  idPrefix: string,
  files: ArrayLike<File | null | undefined>,
  count = 5
): void {
  for (let n = 1; n <= count; n++) {
    const input = document.getElementById(inputId(idPrefix, n)) as HTMLInputElement | null;
    if (!input) {
      continue;
    }
    const file = files[n - 1] ?? null;
    const current = input.files && input.files.length > 0 ? input.files[0] : null;
    if (current === file) {
      continue;
    }
    if (file) {
      const transfer = new DataTransfer();
      transfer.items.add(file);
      input.files = transfer.files;
    } else {
      input.value = '';
    }
  }
}

/** Empty one input of a group (index is 0-based). */
export function clearFileInput(idPrefix: string, index: number): void {
  const input = document.getElementById(inputId(idPrefix, index + 1)) as HTMLInputElement | null;
  if (input) {
    input.value = '';
  }
}
